(function () {
  function initProductGuides(section) {
    if (!section || section.dataset.wfGuidesInitialized === 'true') {
      return;
    }

    section.dataset.wfGuidesInitialized = 'true';

    var button = section.querySelector(
      '[data-wf-guides-request]'
    );

    if (!button) return;

    button.addEventListener('click', function () {
      var customToggle =
        document.querySelector('.wf-custom-toggle');

      if (!customToggle) return;

      customToggle.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      window.setTimeout(function () {
        var box = customToggle.closest(
          '.wf-custom-request-box'
        );

        if (
          box &&
          !box.classList.contains('is-open')
        ) {
          customToggle.click();
        }
      }, 450);
    });
  }

  function initAllProductGuides() {
    document
      .querySelectorAll(
        '[data-wf-component="product-guides"]'
      )
      .forEach(function (section) {
        initProductGuides(section);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllProductGuides
    );
  } else {
    initAllProductGuides();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var section = event.target.querySelector(
        '[data-wf-component="product-guides"]'
      );

      if (section) {
        initProductGuides(section);
      }
    }
  );
})();